module.exports = __webpack_public_path__ + "static/media/plus-large-solid.5860fb3d.svg";